import React from 'react';
import { Link, useLocation } from '@remix-run/react';

import Logo from '~/components/Logo';
import { useLayoutStore } from '~/providers/layout-store-provider';

import { HeaderNavItem } from '../HeaderNavItem';

import styles from './SecondaryHeaderNavGroup.module.css';

function getRepubPath(url: string): string {
  const segments = url.split('/');
  if (segments.length > 1 && segments[1]) {
    return `/${segments[1]}`;
  }

  return '';
}

const SecondaryHeaderNavGroup = () => {
  const links = useLayoutStore((s) => s.navData.secondLevelNav);
  const location = useLocation();
  const resourcesUrl = useLayoutStore((s) => s.resourcesUrl);
  const repub = getRepubPath(location.pathname);

  return (
    <section className={styles.container}>
			<div className={styles.content}>
				<Link title="Oddschecker" to={repub}>
					<div className={styles.logoWrapper}>
						<Logo resourcesUrl={resourcesUrl} />
					</div>
				</Link>
				<ul className={styles.links}>
					{links.map((link, index) =>
          <React.Fragment key={`${link.link}-${index}`}>
							<HeaderNavItem {...link} variant="secondary" />
						</React.Fragment>
          )}
				</ul>
			</div>
		</section>);

};

export { SecondaryHeaderNavGroup };